module.exports = __webpack_public_path__ + "static/media/popup.25945196.png";